import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiUploadedFile, NewUploadedFile, Profile } from '../term-files-section.model';
import { Result } from '@/reservation/reservation.model';

@Injectable({
	providedIn: 'root',
})
export class TermFilesApiService {
	private readonly httpClient = inject(HttpClient);

	getTransportTermFiles(termId: number): Observable<ApiUploadedFile[]> {
		return this.httpClient
			.get<Result<ApiUploadedFile>>(`${environment.apiUrl}/transport/transport_term/${termId}/files/`)
			.pipe(map((result) => result?.results));
	}

	getProfile(): Observable<Profile> {
		return this.httpClient.get<Profile>(`${environment.apiUrl}/profile/`);
	}

	createTransportTermFile(termId: number, file: NewUploadedFile): Observable<ApiUploadedFile> {
		const formData = new FormData();
		formData.append('file', file.file);
		formData.append('note', file.note);
		formData.append('externalUrl', file.externalUrl);
		if (file.documentTypeId !== undefined && file.documentTypeId !== null) {
			formData.append('documentType', String(file.documentTypeId));
		}

		return this.httpClient.post<ApiUploadedFile>(
			`${environment.apiUrl}/transport/transport_term/${termId}/files/`,
			formData,
		);
	}

	deleteTransportTermFile(termId: number, fileId: number): Observable<void> {
		return this.httpClient.delete<void>(
			`${environment.apiUrl}/transport/transport_term/${termId}/files/${fileId}/`,
		);
	}

	updateTransportTermFileVisibility(
		termId: number,
		fileId: number,
		visibleToPilot: boolean,
	): Observable<ApiUploadedFile> {
		return this.httpClient.patch<ApiUploadedFile>(
			`${environment.apiUrl}/transport/transport_term/${termId}/files/${fileId}/`,
			{ visible_to_pilot: visibleToPilot },
		);
	}

	updateTransportTermFileDocumentType(
		termId: number,
		fileId: number,
		documentTypeId: number | null,
	): Observable<ApiUploadedFile> {
		return this.httpClient.patch<ApiUploadedFile>(
			`${environment.apiUrl}/transport/transport_term/${termId}/files/${fileId}/`,
			{ documentType: documentTypeId },
		);
	}
}
